module.exports = __webpack_public_path__ + "static/media/logo-login.0c52f230.png";